import React from 'react';
import FileInput from './FileInput';
import Button from './Button';
import { Tooltip } from 'react-tooltip';
import { getDisplayImageUrl } from '../utils/imageHelpers'; // Import the helper

const FileUpload = ({
  label,
  name,
  id,
  onChange,
  error,
  currentFileUrl,
  onRemoveFile,
  required = false,
  fileType = 'file', // 'image', 'json', 'file'
  fileName = 'File', // e.g., "Image", "Credentials", "File"
  fallbackName = 'File', // Name for avatar if image and no currentFileUrl
}) => {
  const handleViewFile = () => {
    if (currentFileUrl) {
      window.open(getDisplayImageUrl(currentFileUrl, fallbackName, true), '_blank'); // Use helper for full URL
    }
  };

  const getFileNameFromUrl = (url) => {
    try {
      const urlObj = new URL(url);
      const pathSegments = urlObj.pathname.split('/');
      return pathSegments[pathSegments.length - 1];
    } catch (e) {
      return url;
    }
  };

  const displayFileName = currentFileUrl ? getFileNameFromUrl(currentFileUrl) : '';
  const tooltipId = `tooltip-${id}`;

  return (
    <>
      <FileInput
        label={label}
        name={name}
        id={id}
        onChange={onChange}
        error={error}
        required={required}
        currentFileMessage={
          currentFileUrl ? (
            <div className="flex items-center space-x-2">
              <span>Current {fileName}:</span>
              <Button
                type="button"
                onClick={handleViewFile}
                className="text-blue-500 hover:text-blue-600 text-sm max-w-[150px] whitespace-nowrap overflow-hidden text-ellipsis"
                data-tooltip-id={tooltipId}
                data-tooltip-content={displayFileName}
              >
                {displayFileName}
              </Button>
              {onRemoveFile && (
                <Button
                  type="button"
                  onClick={onRemoveFile}
                  className="text-red-500 hover:text-red-600 text-sm"
                >
                  Remove
                </Button>
              )}
            </div>
          ) : (
            "No current file"
          )
        }
      />
      {currentFileUrl && <Tooltip id={tooltipId} />}
    </>
  );
};

export default FileUpload;